import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchProposals } from "./api";
import type { ProposalsResponse } from "./api";

// Список предложений самообучения. Org-scoped запрос (см.
// `src/query/scope.ts`). В отличие от очереди/квот, список не
// realtime-критичен (предложения копятся фоновым анализом редко) —
// поллинг не ставим, обновление через invalidateQueries после
// apply/reject.
export function useProposals(): UseQueryResult<ProposalsResponse, Error> {
  return useOrgScopedQuery<ProposalsResponse>({
    key: ["self-improvement", "proposals"],
    queryFn: () => fetchProposals(),
    retry: false,
  });
}
